import clsx from "clsx"

import { getPriorityIcon } from "@utils/priority"

import Icon from "@atoms/Icon/Icon"

import { PriorityIconProps } from "./PriorityIcon.types"
import { getPriorityIconClassName } from "./PriorityIcon.utils"

// The priority glyph in a square container, so every level takes the same width wherever it appears.
export default function PriorityIcon(props: PriorityIconProps) {
    const { priority, size = 14, className } = props

    return (
        <Icon
            icon={getPriorityIcon(priority)}
            size={size}
            container="square"
            className={clsx(getPriorityIconClassName(priority), className)}
        />
    )
}
